module.exports = __webpack_public_path__ + "img/gushu.2f751c3a.svg";